import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import { formatMoney } from "../config/store";

function Shop() {
  return <main className="shop main" id="main"><section className="product-carousel-section"><h2>Shop all</h2><div className="product-grid trending-grid">
    {productData.map((product) => <div key={product.id} className="product-card"><Link to={`/shopDetails/${product.id}`} onClick={() => window.scrollTo({ top: 0 })}><div className="img-wrapper"><img src={product.image} alt={product.name}/></div><div className="product-info"><p className="price">{formatMoney(product.price)} USD</p><p className="name">{product.name}</p><p className={`stock ${product.purchasable ? "" : "stock--hold"}`}>{product.purchasable ? `${product.inventory} available` : "Documentation pending — unavailable"}</p></div></Link></div>)}
  </div></section></main>;
}
export default Shop;
